import React, {type PropsWithChildren, createContext, useContext} from 'react'

import type {TariffsConfig} from './types'

const TariffsConfigContext = createContext<TariffsConfig | null>(null)

type Props = PropsWithChildren<{
  config: TariffsConfig
}>

export function TariffsConfigProvider({config, children}: Props) {
  return <TariffsConfigContext.Provider value={config}>{children}</TariffsConfigContext.Provider>
}

export function useConfig() {
  const config = useContext(TariffsConfigContext)

  if (!config) {
    throw new Error('You should wrap your app in TariffsConfigProvider')
  }

  return config
}
